module.exports = __webpack_public_path__ + "img/logo-216x52.0957524b.svg";